function updateInventoryBadges() {
  const nodes = Array.from(document.querySelectorAll('.js-inv-badge[data-total-inventory]'));
  if (!nodes.length) return;

  nodes.forEach(node => {
    const totalInventory = parseInt(node.getAttribute('data-total-inventory') || '0', 10);
    const threshold = parseInt(node.getAttribute('data-threshold') || '10', 10);

    if (totalInventory > 0 && totalInventory < threshold) {
      const template = node.getAttribute('data-text-template') || '{qty} LEFT 🔥';
      node.textContent = template.replace('{qty}', totalInventory);
      node.hidden = false;
    } else if (totalInventory === 0) {
      node.hidden = true; // sold out handled elsewhere
    } else {
      node.hidden = true; // plenty in stock
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateInventoryBadges();

  const paginationNode = document.getElementById('Huratips-Pagination');
  if (paginationNode) {
    let previousText = '';
    
    const observer = new MutationObserver(() => {
      const linkElement = paginationNode.querySelector('a');
      if (linkElement) {
        const currentText = linkElement.textContent.trim();
        
        if (previousText === 'Loading...' && currentText === 'Loading More') {
          updateInventoryBadges();
        }
        
        previousText = currentText;
      }
    });

    observer.observe(paginationNode, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
});